import React from 'react';
import {connect} from 'react-redux';
import {getFromHub, getImageUrlById, getResourceImageUrl} from '../actions/networkActions';
import {setCruiseImage} from '../actions/cruisesActions';
import ImageWithFallback from "./ImageWithFallback";

class CruiseHeaderImage extends React.Component {

    componentDidMount() {
        if(!this.props.cruiseImageId && !this.props.imageReferenceId) {
            getFromHub('prebooking/cruises/firstExcursions', setCruiseImage);
        }
    }

    render() {
        if(!this.props.cruiseImageId && !this.props.imageReferenceId) {
            return null;
        }

        return (
            <div className="container-2-1 md:full-height-container xl:container-2-1">
                <ImageWithFallback
                    className="container-2-1-img md:full-height-container-img xl:container-2-1-img cover-fit"
                    alt="cruise header"
                    src={ this.props.cruiseImageId ?
                        getImageUrlById(this.props.cruiseImageId, {width: "800",category: "cruiseExcursion"}) :
                        getResourceImageUrl(this.props.imageReferenceId, {width: "800", category: "cruiseExcursion"})}
                />
                {this.props.children}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        imageReferenceId: state.cruises?.imageReferenceId,
        cruiseImageId: state.cruises?.cruiseDetails?.[0]?.image?.id
    }
}

export default connect(mapStateToProps) (CruiseHeaderImage);